// extracted by mini-css-extract-plugin
export default {"link":"zC-z","disabled":"AC-z"};